import React from "react";

import { theme } from "../../styles/theme";

type IconsProp = {
  name: string;
  width: number;
  height: number;
  color?: string;
};

function Icons({
  name,
  width,
  height,
  color = theme.colors.black,
}: IconsProp): JSX.Element {
  switch (name) {
    case "arrow-right":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 12 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.6364 1.3636C2.28492 1.01213 1.71508 1.01213 1.3636 1.3636C1.01213 1.71508 1.01213 2.28492 1.3636 2.6364L8.72721 10L1.3636 17.3636C1.01213 17.7151 1.01213 18.2849 1.3636 18.6364C1.71508 18.9879 2.28492 18.9879 2.6364 18.6364L10.6364 10.6364C10.9879 10.2849 10.9879 9.71508 10.6364 9.3636L2.6364 1.3636Z"
            fill={color}
            stroke={color}
            strokeWidth="0.3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case "close":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.955 6.65385L14.1425 0.307693L15.91 2.12051L9.7225 8.46667L15.91 14.8128L14.1425 16.6256L7.955 10.2795L1.7675 16.6256L0 14.8128L6.1875 8.46667L0 2.12051L1.7675 0.307693L7.955 6.65385Z"
            fill={color}
          />
        </svg>
      );
    case "update":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.05 12.5641L21 17.6411L16.05 22.718L14.636 21.2677L17.172 18.6657L4 18.6667V16.6154H17.172L14.636 14.0144L16.05 12.5641ZM7.95 2.30774L9.364 3.758L6.828 6.35902H20V8.4103H6.828L9.364 11.0113L7.95 12.4616L3 7.38466L7.95 2.30774V2.30774Z"
            fill={color}
          />
        </svg>
      );
    case "ni":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 32 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.5 32.1393V0.800049H16.5027L16.861 1.16166L24.0263 8.3938L24.3846 8.75541V12.8536H21.9962V10.4429H14.8308V3.21076H2.88846V29.7286H19.6077V32.1393H0.5Z"
            fill={color}
          />
          <path
            d="M5.27692 15.2643V12.8536H19.6077V15.2643H5.27692Z"
            fill={color}
          />
          <path
            d="M5.27692 21.2911V18.8804H13.6365V21.2911H5.27692Z"
            fill={color}
          />
          <path
            d="M16.025 21.2911V18.8804H19.6077V21.2911H16.025Z"
            fill={color}
          />
          <path
            d="M5.27692 26.1126V23.7018H13.6365V26.1126H5.27692Z"
            fill={color}
          />
          <path
            d="M16.025 26.1126V23.7018H19.6077V26.1126H16.025Z"
            fill={color}
          />
          <circle cx="23" cy="25" r="9" fill="white" />
          <path
            d="M18.7562 28.4616H20.1131V21.6963H18.7562V28.4616Z"
            fill={color}
          />
          <path
            d="M25.8832 21.6866V26.339L22.8107 21.6866H21.4538V28.4616H22.8107V23.819L25.8832 28.4616H27.2401V21.6866H25.8832Z"
            fill={color}
          />
        </svg>
      );
    case "documents":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M2.7 5.4H0V24.3C0 25.785 1.215 27 2.7 27H21.6V24.3H2.7V5.4ZM24.3 0H8.1C6.615 0 5.4 1.215 5.4 2.7V18.9C5.4 20.385 6.615 21.6 8.1 21.6H24.3C25.785 21.6 27 20.385 27 18.9V2.7C27 1.215 25.785 0 24.3 0ZM24.3 18.9H8.1V2.7H24.3V18.9ZM10.8 9.45H21.6V12.15H10.8V9.45ZM10.8 13.5H16.2V16.2H10.8V13.5ZM10.8 5.4H21.6V8.1H10.8V5.4Z"
            fill={color}
          />
        </svg>
      );
    case "exit":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 25 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M20.3339 9.07153L23.6071 13.0001L20.3339 9.07153ZM20.3339 16.9287L23.6071 13.0001L20.3339 16.9287Z"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.6429 13H11.4286M2 2H16.1429M2 24H16.1429M16.1429 2V8.28571M16.1429 17.7143V24M2 2V24"
            stroke={color}
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
      );
    case "nf":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 28 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0.5 0.800049V33.2001H26.15V9.02467L25.7653 8.65082L18.0703 1.17389L17.6855 0.800049H0.5ZM3.065 3.29236H15.89V10.7693H23.585V30.7077H3.065V3.29236ZM18.455 5.03697L21.7895 8.27697H18.455V5.03697ZM5.63 13.2616V15.7539H21.02V13.2616H5.63ZM5.63 19.4924V21.9847H14.6075V19.4924H5.63ZM17.1725 19.4924V21.9847H21.02V19.4924H17.1725ZM5.63 24.477V26.9693H14.6075V24.477H5.63ZM17.1725 24.477V26.9693H21.02V24.477H17.1725Z"
            fill={color}
          />
          <circle cx="19" cy="27" r="9" fill="white" />
          <path
            d="M17.8673 23.6865V28.3388L14.7948 23.6865H13.4379V30.4614H14.7948V25.8188L17.8673 30.4614H19.2242V23.6865H17.8673Z"
            fill={color}
          />
          <path
            d="M20.5651 30.4614H21.922V27.6022H24.0834V26.5264H21.922V24.7914H24.7425V23.6962H20.5651V30.4614Z"
            fill={color}
          />
        </svg>
      );
    case "file-dock":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.1716 3H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7V17C5 18.8856 5 19.8284 5.58579 20.4142C6.17157 21 7.11438 21 9 21H15C16.8856 21 17.8284 21 18.4142 20.4142C19 19.8284 19 18.8856 19 17V8.82843C19 8.41968 19 8.2153 18.9239 8.03153C18.8478 7.84776 18.7032 7.70324 18.4142 7.41421L14.5858 3.58579C14.2968 3.29676 14.1522 3.15224 13.9685 3.07612C13.7847 3 13.5803 3 13.1716 3Z"
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M9 13L15 13"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M9 17L13 17"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M13 3V7C13 7.94281 13 8.41421 13.2929 8.70711C13.5858 9 14.0572 9 15 9H19"
            stroke={color}
            strokeWidth="2"
          />
        </svg>
      );
    case "upload":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 9.25C19.4142 9.25 19.75 9.58579 19.75 10V19C19.75 19.4142 19.4142 19.75 19 19.75H1C0.585786 19.75 0.25 19.4142 0.25 19V10.0042C0.25 9.58994 0.585786 9.25415 1 9.25415C1.41421 9.25415 1.75 9.58994 1.75 10.0042V18.25H18.25V10C18.25 9.58579 18.5858 9.25 19 9.25Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.46967 0.46967C9.76256 0.176777 10.2374 0.176777 10.5303 0.46967L15.0303 4.96967C15.3232 5.26256 15.3232 5.73744 15.0303 6.03033C14.7374 6.32322 14.2626 6.32322 13.9697 6.03033L10 2.06066L6.03033 6.03033C5.73744 6.32322 5.26256 6.32322 4.96967 6.03033C4.67678 5.73744 4.67678 5.26256 4.96967 4.96967L9.46967 0.46967Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.99609 0.25C10.4103 0.25 10.7461 0.585786 10.7461 1V14C10.7461 14.4142 10.4103 14.75 9.99609 14.75C9.58188 14.75 9.24609 14.4142 9.24609 14V1C9.24609 0.585786 9.58188 0.25 9.99609 0.25Z"
            fill={color}
          />
        </svg>
      );
    case "download":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21 11.25C21.4142 11.25 21.75 11.5858 21.75 12V21C21.75 21.4142 21.4142 21.75 21 21.75H3C2.58579 21.75 2.25 21.4142 2.25 21V12.0042C2.25 11.5899 2.58579 11.2542 3 11.2542C3.41421 11.2542 3.75 11.5899 3.75 12.0042V20.25H20.25V12C20.25 11.5858 20.5858 11.25 21 11.25Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.96967 10.9697C7.26256 10.6768 7.73744 10.6768 8.03033 10.9697L12 14.9393L15.9697 10.9697C16.2626 10.6768 16.7374 10.6768 17.0303 10.9697C17.3232 11.2626 17.3232 11.7374 17.0303 12.0303L12.5303 16.5303C12.2374 16.8232 11.7626 16.8232 11.4697 16.5303L6.96967 12.0303C6.67678 11.7374 6.67678 11.2626 6.96967 10.9697Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.9961 2.25C12.4103 2.25 12.7461 2.58579 12.7461 3V16C12.7461 16.4142 12.4103 16.75 11.9961 16.75C11.5819 16.75 11.2461 16.4142 11.2461 16V3C11.2461 2.58579 11.5819 2.25 11.9961 2.25Z"
            fill={color}
          />
        </svg>
      );
    case "all-users":
      return (
        <svg
          width="132"
          height="132"
          viewBox="0 0 132 132"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            d="M66 59.4C74.7521 59.4 83.1458 62.8768 89.3345 69.0655C95.5232 75.2542 99 83.6479 99 92.4V132H85.8V92.4C85.8003 87.3496 83.8707 82.49 80.4059 78.8155C76.9412 75.141 72.2033 72.9293 67.1616 72.633L66 72.6C60.9496 72.5997 56.09 74.5293 52.4155 77.9941C48.741 81.4588 46.5293 86.1967 46.233 91.2384L46.2 92.4V132H33V92.4C33 83.6479 36.4768 75.2542 42.6655 69.0655C48.8542 62.8768 57.2479 59.4 66 59.4ZM23.1 79.2C24.9414 79.2 26.73 79.4178 28.446 79.8204C27.3176 83.1798 26.6493 86.6766 26.4594 90.2154L26.4 92.4V92.9676C25.6414 92.6961 24.8523 92.5188 24.0504 92.4396L23.1 92.4C20.639 92.4001 18.2662 93.3169 16.4444 94.9715C14.6226 96.6261 13.4825 98.8999 13.2462 101.35L13.2 102.3V132H0V102.3C0 96.1735 2.43374 90.2979 6.76583 85.9658C11.0979 81.6337 16.9735 79.2 23.1 79.2ZM108.9 79.2C115.027 79.2 120.902 81.6337 125.234 85.9658C129.566 90.2979 132 96.1735 132 102.3V132H118.8V102.3C118.8 99.839 117.883 97.4662 116.229 95.6444C114.574 93.8226 112.3 92.6825 109.85 92.4462L108.9 92.4C107.745 92.4 106.636 92.598 105.6 92.961V92.4C105.6 88.0044 104.887 83.7804 103.561 79.8336C105.27 79.4178 107.059 79.2 108.9 79.2ZM23.1 39.6C27.4761 39.6 31.6729 41.3384 34.7673 44.4327C37.8616 47.5271 39.6 51.7239 39.6 56.1C39.6 60.4761 37.8616 64.6729 34.7673 67.7673C31.6729 70.8616 27.4761 72.6 23.1 72.6C18.7239 72.6 14.5271 70.8616 11.4327 67.7673C8.33839 64.6729 6.6 60.4761 6.6 56.1C6.6 51.7239 8.33839 47.5271 11.4327 44.4327C14.5271 41.3384 18.7239 39.6 23.1 39.6ZM108.9 39.6C113.276 39.6 117.473 41.3384 120.567 44.4327C123.662 47.5271 125.4 51.7239 125.4 56.1C125.4 60.4761 123.662 64.6729 120.567 67.7673C117.473 70.8616 113.276 72.6 108.9 72.6C104.524 72.6 100.327 70.8616 97.2327 67.7673C94.1384 64.6729 92.4 60.4761 92.4 56.1C92.4 51.7239 94.1384 47.5271 97.2327 44.4327C100.327 41.3384 104.524 39.6 108.9 39.6ZM23.1 52.8C22.2248 52.8 21.3854 53.1477 20.7665 53.7665C20.1477 54.3854 19.8 55.2248 19.8 56.1C19.8 56.9752 20.1477 57.8146 20.7665 58.4335C21.3854 59.0523 22.2248 59.4 23.1 59.4C23.9752 59.4 24.8146 59.0523 25.4335 58.4335C26.0523 57.8146 26.4 56.9752 26.4 56.1C26.4 55.2248 26.0523 54.3854 25.4335 53.7665C24.8146 53.1477 23.9752 52.8 23.1 52.8ZM108.9 52.8C108.025 52.8 107.185 53.1477 106.567 53.7665C105.948 54.3854 105.6 55.2248 105.6 56.1C105.6 56.9752 105.948 57.8146 106.567 58.4335C107.185 59.0523 108.025 59.4 108.9 59.4C109.775 59.4 110.615 59.0523 111.233 58.4335C111.852 57.8146 112.2 56.9752 112.2 56.1C112.2 55.2248 111.852 54.3854 111.233 53.7665C110.615 53.1477 109.775 52.8 108.9 52.8ZM66 0C73.0017 0 79.7167 2.78142 84.6676 7.73238C89.6186 12.6833 92.4 19.3983 92.4 26.4C92.4 33.4017 89.6186 40.1167 84.6676 45.0676C79.7167 50.0186 73.0017 52.8 66 52.8C58.9983 52.8 52.2833 50.0186 47.3324 45.0676C42.3814 40.1167 39.6 33.4017 39.6 26.4C39.6 19.3983 42.3814 12.6833 47.3324 7.73238C52.2833 2.78142 58.9983 0 66 0ZM66 13.2C62.4991 13.2 59.1417 14.5907 56.6662 17.0662C54.1907 19.5417 52.8 22.8991 52.8 26.4C52.8 29.9009 54.1907 33.2583 56.6662 35.7338C59.1417 38.2093 62.4991 39.6 66 39.6C69.5009 39.6 72.8583 38.2093 75.3338 35.7338C77.8093 33.2583 79.2 29.9009 79.2 26.4C79.2 22.8991 77.8093 19.5417 75.3338 17.0662C72.8583 14.5907 69.5009 13.2 66 13.2Z"
            fill={color}
          />
        </svg>
      );
    case "add-user":
      return (
        <svg
          width="115"
          height="127"
          viewBox="0 0 115 127"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            d="M60.5263 80.143V92.7826C55.0482 90.8474 49.1853 90.2538 43.4301 91.0517C37.6748 91.8495 32.1952 94.0156 27.4513 97.3679C22.7074 100.72 18.8379 105.161 16.1676 110.317C13.4973 115.473 12.1042 121.194 12.1053 127L1.56434e-06 126.994C-0.00187701 119.609 1.68821 112.322 4.94076 105.691C8.1933 99.0593 12.922 93.2599 18.7645 88.7369C24.607 84.2139 31.4082 81.0873 38.647 79.5966C45.8858 78.1059 53.3701 78.2908 60.5263 80.137V80.143ZM48.4211 72.5714C28.3566 72.5714 12.1053 56.3336 12.1053 36.2857C12.1053 16.2379 28.3566 0 48.4211 0C68.4855 0 84.7368 16.2379 84.7368 36.2857C84.7368 56.3336 68.4855 72.5714 48.4211 72.5714ZM48.4211 60.4762C61.7974 60.4762 72.6316 49.651 72.6316 36.2857C72.6316 22.9205 61.7974 12.0952 48.4211 12.0952C35.0447 12.0952 24.2105 22.9205 24.2105 36.2857C24.2105 49.651 35.0447 60.4762 48.4211 60.4762ZM84.7368 96.7619V78.619H96.8421V96.7619H115V108.857H96.8421V127H84.7368V108.857H66.5789V96.7619H84.7368Z"
            fill={color}
          />
        </svg>
      );
    case "new-user":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 140 140"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            opacity="0.5"
            d="M0 140C0 125.855 5.61903 112.29 15.621 102.288C25.6229 92.2857 39.1885 86.6667 53.3333 86.6667C67.4782 86.6667 81.0438 92.2857 91.0457 102.288C101.048 112.29 106.667 125.855 106.667 140H93.3333C93.3333 129.391 89.1191 119.217 81.6176 111.716C74.1161 104.214 63.942 100 53.3333 100C42.7247 100 32.5505 104.214 25.0491 111.716C17.5476 119.217 13.3333 129.391 13.3333 140H0ZM53.3333 80C31.2333 80 13.3333 62.1 13.3333 40C13.3333 17.9 31.2333 0 53.3333 0C75.4333 0 93.3333 17.9 93.3333 40C93.3333 62.1 75.4333 80 53.3333 80ZM53.3333 66.6667C68.0667 66.6667 80 54.7333 80 40C80 25.2667 68.0667 13.3333 53.3333 13.3333C38.6 13.3333 26.6667 25.2667 26.6667 40C26.6667 54.7333 38.6 66.6667 53.3333 66.6667ZM108.56 91.3533C117.929 95.5728 125.88 102.408 131.457 111.038C137.035 119.668 140.001 129.725 140 140H126.667C126.668 132.293 124.444 124.75 120.261 118.277C116.077 111.804 110.114 106.678 103.087 103.513L108.553 91.3533H108.56ZM103.973 16.0867C110.69 18.8553 116.433 23.5569 120.473 29.5949C124.514 35.6328 126.669 42.7349 126.667 50C126.669 59.1489 123.251 67.9682 117.084 74.7255C110.916 81.4828 102.444 85.6898 93.3333 86.52V73.1C98.2729 72.3925 102.856 70.1201 106.409 66.6164C109.962 63.1126 112.298 58.5621 113.074 53.6329C113.851 48.7036 113.027 43.6553 110.723 39.229C108.419 34.8027 104.756 31.2316 100.273 29.04L103.973 16.0867Z"
            fill={color}
          />
        </svg>
      );
    case "home":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.4368 27.8H22.4003V18.35C22.4003 17.6035 21.7955 17 21.0503 17H12.9503C12.2038 17 11.6003 17.6035 11.6003 18.35V27.8H7.55034L7.55844 16.4371L16.9976 6.7832L26.4503 16.4924L26.4368 27.8ZM14.3003 27.8H19.7003V19.7H14.3003V27.8ZM28.3727 14.5498L17.9656 3.90635C17.4566 3.3866 16.544 3.3866 16.0351 3.90635L5.62659 14.5511C5.13384 15.0574 4.85034 15.7648 4.85034 16.4924V27.8C4.85034 29.2891 5.99379 30.5 7.39914 30.5H12.9503H21.0503H26.6002C28.0055 30.5 29.1503 29.2891 29.1503 27.8V16.4924C29.1503 15.7648 28.8668 15.0574 28.3727 14.5498Z"
            fill={color}
          />
        </svg>
      );
    case "user":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 25 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12.1053 15.7762V18.2643C11.0096 17.8833 9.83707 17.7665 8.68602 17.9236C7.53496 18.0806 6.43903 18.507 5.49026 19.1669C4.54149 19.8268 3.76757 20.701 3.23351 21.716C2.69945 22.731 2.42083 23.8572 2.42105 25L3.12868e-07 24.9988C-0.000375401 23.5451 0.337642 22.1106 0.988151 20.8052C1.63866 19.4999 2.5844 18.3583 3.75289 17.4679C4.92139 16.5775 6.28163 15.9621 7.7294 15.6686C9.17716 15.3752 10.674 15.4116 12.1053 15.775V15.7762ZM9.68421 14.2857C5.67132 14.2857 2.42105 11.0893 2.42105 7.14286C2.42105 3.19643 5.67132 0 9.68421 0C13.6971 0 16.9474 3.19643 16.9474 7.14286C16.9474 11.0893 13.6971 14.2857 9.68421 14.2857ZM9.68421 11.9048C12.3595 11.9048 14.5263 9.77381 14.5263 7.14286C14.5263 4.5119 12.3595 2.38095 9.68421 2.38095C7.00895 2.38095 4.84211 4.5119 4.84211 7.14286C4.84211 9.77381 7.00895 11.9048 9.68421 11.9048ZM16.9474 19.0476V15.4762H19.3684V19.0476H23V21.4286H19.3684V25H16.9474V21.4286H13.3158V19.0476H16.9474Z"
            fill={color}
          />
        </svg>
      );
    case "users":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15 13.75C16.6576 13.75 18.2473 14.4085 19.4194 15.5806C20.5915 16.7527 21.25 18.3424 21.25 20V27.5H18.75V20C18.7501 19.0435 18.3846 18.1231 17.7284 17.4272C17.0722 16.7312 16.1749 16.3124 15.22 16.2563L15 16.25C14.0435 16.2499 13.1231 16.6154 12.4272 17.2716C11.7312 17.9278 11.3124 18.8251 11.2563 19.78L11.25 20V27.5H8.75V20C8.75 18.3424 9.40848 16.7527 10.5806 15.5806C11.7527 14.4085 13.3424 13.75 15 13.75ZM6.875 17.5C7.22375 17.5 7.5625 17.5412 7.8875 17.6175C7.67378 18.2538 7.54721 18.916 7.51125 19.5862L7.5 20V20.1075C7.35632 20.0561 7.20687 20.0225 7.055 20.0075L6.875 20C6.4089 20 5.95951 20.1736 5.61448 20.487C5.26944 20.8004 5.0535 21.2311 5.00875 21.695L5 21.875V27.5H2.5V21.875C2.5 20.7147 2.96094 19.6019 3.78141 18.7814C4.60188 17.9609 5.71468 17.5 6.875 17.5V17.5ZM23.125 17.5C24.2853 17.5 25.3981 17.9609 26.2186 18.7814C27.0391 19.6019 27.5 20.7147 27.5 21.875V27.5H25V21.875C25 21.4089 24.8264 20.9595 24.513 20.6145C24.1996 20.2694 23.7689 20.0535 23.305 20.0087L23.125 20C22.9063 20 22.6963 20.0375 22.5 20.1062V20C22.5 19.1675 22.365 18.3675 22.1137 17.62C22.4375 17.5412 22.7762 17.5 23.125 17.5ZM6.875 10C7.7038 10 8.49866 10.3292 9.08471 10.9153C9.67076 11.5013 10 12.2962 10 13.125C10 13.9538 9.67076 14.7487 9.08471 15.3347C8.49866 15.9208 7.7038 16.25 6.875 16.25C6.0462 16.25 5.25134 15.9208 4.66529 15.3347C4.07924 14.7487 3.75 13.9538 3.75 13.125C3.75 12.2962 4.07924 11.5013 4.66529 10.9153C5.25134 10.3292 6.0462 10 6.875 10V10ZM23.125 10C23.9538 10 24.7487 10.3292 25.3347 10.9153C25.9208 11.5013 26.25 12.2962 26.25 13.125C26.25 13.9538 25.9208 14.7487 25.3347 15.3347C24.7487 15.9208 23.9538 16.25 23.125 16.25C22.2962 16.25 21.5013 15.9208 20.9153 15.3347C20.3292 14.7487 20 13.9538 20 13.125C20 12.2962 20.3292 11.5013 20.9153 10.9153C21.5013 10.3292 22.2962 10 23.125 10V10ZM6.875 12.5C6.70924 12.5 6.55027 12.5658 6.43306 12.6831C6.31585 12.8003 6.25 12.9592 6.25 13.125C6.25 13.2908 6.31585 13.4497 6.43306 13.5669C6.55027 13.6842 6.70924 13.75 6.875 13.75C7.04076 13.75 7.19973 13.6842 7.31694 13.5669C7.43415 13.4497 7.5 13.2908 7.5 13.125C7.5 12.9592 7.43415 12.8003 7.31694 12.6831C7.19973 12.5658 7.04076 12.5 6.875 12.5ZM23.125 12.5C22.9592 12.5 22.8003 12.5658 22.6831 12.6831C22.5658 12.8003 22.5 12.9592 22.5 13.125C22.5 13.2908 22.5658 13.4497 22.6831 13.5669C22.8003 13.6842 22.9592 13.75 23.125 13.75C23.2908 13.75 23.4497 13.6842 23.5669 13.5669C23.6842 13.4497 23.75 13.2908 23.75 13.125C23.75 12.9592 23.6842 12.8003 23.5669 12.6831C23.4497 12.5658 23.2908 12.5 23.125 12.5ZM15 2.5C16.3261 2.5 17.5979 3.02678 18.5355 3.96447C19.4732 4.90215 20 6.17392 20 7.5C20 8.82608 19.4732 10.0979 18.5355 11.0355C17.5979 11.9732 16.3261 12.5 15 12.5C13.6739 12.5 12.4021 11.9732 11.4645 11.0355C10.5268 10.0979 10 8.82608 10 7.5C10 6.17392 10.5268 4.90215 11.4645 3.96447C12.4021 3.02678 13.6739 2.5 15 2.5V2.5ZM15 5C14.337 5 13.7011 5.26339 13.2322 5.73223C12.7634 6.20107 12.5 6.83696 12.5 7.5C12.5 8.16304 12.7634 8.79893 13.2322 9.26777C13.7011 9.73661 14.337 10 15 10C15.663 10 16.2989 9.73661 16.7678 9.26777C17.2366 8.79893 17.5 8.16304 17.5 7.5C17.5 6.83696 17.2366 6.20107 16.7678 5.73223C16.2989 5.26339 15.663 5 15 5V5Z"
            fill={color}
          />
        </svg>
      );
    case "trash":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10 15L10 12"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M14 15L14 12"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M3 7H21V7C20.0681 7 19.6022 7 19.2346 7.15224C18.7446 7.35523 18.3552 7.74458 18.1522 8.23463C18 8.60218 18 9.06812 18 10V16C18 17.8856 18 18.8284 17.4142 19.4142C16.8284 20 15.8856 20 14 20H10C8.11438 20 7.17157 20 6.58579 19.4142C6 18.8284 6 17.8856 6 16V10C6 9.06812 6 8.60218 5.84776 8.23463C5.64477 7.74458 5.25542 7.35523 4.76537 7.15224C4.39782 7 3.93188 7 3 7V7Z"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M10.0681 3.37059C10.1821 3.26427 10.4332 3.17033 10.7825 3.10332C11.1318 3.03632 11.5597 3 12 3C12.4403 3 12.8682 3.03632 13.2175 3.10332C13.5668 3.17033 13.8179 3.26427 13.9319 3.37059"
            stroke={color}
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );
    case "check":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M10.8907 15.172L20.0903 5.979L21.5065 7.393L10.8907 18L4.52148 11.636L5.93665 10.222L10.8907 15.172Z"
            fill={color}
          />
        </svg>
      );
    case "people":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 16 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 21C0 18.8783 0.842855 16.8434 2.34315 15.3431C3.84344 13.8429 5.87827 13 8 13C10.1217 13 12.1566 13.8429 13.6569 15.3431C15.1571 16.8434 16 18.8783 16 21H14C14 19.4087 13.3679 17.8826 12.2426 16.7574C11.1174 15.6321 9.5913 15 8 15C6.4087 15 4.88258 15.6321 3.75736 16.7574C2.63214 17.8826 2 19.4087 2 21H0ZM8 12C4.685 12 2 9.315 2 6C2 2.685 4.685 0 8 0C11.315 0 14 2.685 14 6C14 9.315 11.315 12 8 12ZM8 10C10.21 10 12 8.21 12 6C12 3.79 10.21 2 8 2C5.79 2 4 3.79 4 6C4 8.21 5.79 10 8 10Z"
            fill={color}
          />
        </svg>
      );
    case "edit":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.3157 10.7954L19.1113 8.99835C19.6552 8.45405 19.9271 8.1819 20.0726 7.88841C20.3502 7.32865 20.3502 6.67134 20.0726 6.11158C19.9271 5.8181 19.6552 5.54596 19.1114 5.00168L19.1113 5.00165L19.1113 5.00165C18.5667 4.45654 18.2943 4.18398 18.0006 4.03817C17.4404 3.76006 16.7823 3.76006 16.222 4.03817C15.9283 4.18398 15.656 4.45653 15.1113 5.00163L15.1113 5.00165L13.2965 6.818C14.2594 8.4682 15.6444 9.84372 17.3157 10.7954ZM11.8424 8.27328L4.97768 15.1437L4.97767 15.1437C4.55298 15.5687 4.34064 15.7812 4.20104 16.0422C4.06144 16.3033 4.00257 16.5979 3.88483 17.1871L3.26984 20.2645C3.20337 20.5972 3.17014 20.7635 3.26476 20.8581C3.35938 20.9527 3.52568 20.9194 3.85828 20.8528L6.93066 20.2378C7.52036 20.1198 7.81521 20.0608 8.07638 19.9209C8.33755 19.781 8.55009 19.5683 8.97517 19.1429L15.8585 12.2539C14.2379 11.2381 12.8672 9.87596 11.8424 8.27328Z"
            fill={color}
          />
        </svg>
      );
    case "eye":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.1907 12C15.1907 13.6576 13.8482 15 12.194 15C10.5397 15 9.19727 13.6576 9.19727 12C9.19727 10.3424 10.5397 9 12.194 9C13.8482 9 15.1907 10.3424 15.1907 12Z"
            stroke={color}
            strokeWidth="2"
          />
          <path
            d="M20.376 10.9348C20.7636 11.4059 20.9574 11.6414 20.9574 12C20.9574 12.3586 20.7636 12.5941 20.376 13.0652C18.9573 14.7892 15.8274 18 12.1942 18C8.56112 18 5.43122 14.7892 4.01251 13.0652C3.62486 12.5941 3.43103 12.3586 3.43103 12C3.43103 11.6414 3.62486 11.4059 4.01251 10.9348C5.43122 9.21082 8.56112 6 12.1942 6C15.8274 6 18.9573 9.21082 20.376 10.9348Z"
            stroke={color}
            strokeWidth="2"
          />
        </svg>
      );
    case "settings":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.1683 2.1848C12.6261 2.05806 13.1099 2.27093 13.3258 2.69411C13.8232 3.66909 14.8351 4.33322 16.0003 4.33322C17.1655 4.33322 18.1774 3.66909 18.6748 2.69411C18.8907 2.27093 19.3745 2.05806 19.8324 2.1848C22.0783 2.8065 24.1015 3.96041 25.7582 5.50087C26.0817 5.8017 26.1695 6.27918 25.9742 6.67542C25.7778 7.07367 25.667 7.52242 25.667 7.99988C25.667 9.65672 27.0101 10.9999 28.667 10.9999L28.7088 10.9996C29.1509 10.9933 29.5447 11.278 29.6772 11.6998C30.1039 13.0585 30.3337 14.5033 30.3337 15.9999C30.3337 16.9876 30.2336 17.9531 30.0427 18.8863C29.9401 19.388 29.4749 19.7312 28.9652 19.6811C28.8675 19.6715 28.768 19.6665 28.667 19.6665C27.0101 19.6665 25.667 21.0097 25.667 22.6665C25.667 23.404 25.9318 24.0771 26.3727 24.5996C26.703 24.9911 26.6841 25.5688 26.3289 25.9379C24.6373 27.6957 22.4997 29.0236 20.0965 29.7391C19.5746 29.8945 19.0244 29.6038 18.8586 29.0852C18.4716 27.8745 17.3368 26.9999 16.0003 26.9999C14.6638 26.9999 13.5291 27.8745 13.142 29.0852C12.9763 29.6038 12.426 29.8945 11.9042 29.7391C9.50093 29.0236 7.36338 27.6957 5.6717 25.9379C5.31653 25.5688 5.29764 24.9911 5.62795 24.5996C6.06884 24.0771 6.33366 23.404 6.33366 22.6665C6.33366 21.0097 4.99051 19.6665 3.33366 19.6665C3.23263 19.6665 3.13316 19.6715 3.03544 19.6811C2.52573 19.7312 2.06058 19.388 1.95794 18.8863C1.76706 17.9531 1.66699 16.9876 1.66699 15.9999C1.66699 14.5033 1.89669 13.0585 2.32348 11.6998C2.45597 11.278 2.84972 10.9933 3.29179 10.9996L3.33366 10.9999C4.99051 10.9999 6.33366 9.65672 6.33366 7.99988C6.33366 7.52242 6.22284 7.07367 6.02648 6.67542C5.83112 6.27918 5.91891 5.8017 6.24244 5.50087C7.89914 3.96041 9.92237 2.8065 12.1683 2.1848ZM8.11068 6.51976C8.25569 6.98819 8.33366 7.48553 8.33366 7.99988C8.33366 10.5191 6.47047 12.6033 4.04689 12.9494C3.79896 13.9241 3.66699 14.946 3.66699 15.9999C3.66699 16.5724 3.70593 17.1353 3.78121 17.6863C6.33296 17.9127 8.33366 20.056 8.33366 22.6665C8.33366 23.5558 8.10085 24.392 7.69328 25.1161C8.8356 26.1577 10.1737 26.987 11.6452 27.5425C12.5031 26.0251 14.131 24.9999 16.0003 24.9999C17.8696 24.9999 19.4976 26.0251 20.3555 27.5425C21.827 26.987 23.1651 26.1577 24.3074 25.1161C23.8998 24.392 23.667 23.5558 23.667 22.6665C23.667 20.056 25.6677 17.9127 28.2194 17.6863C28.2947 17.1353 28.3337 16.5724 28.3337 15.9999C28.3337 14.946 28.2017 13.9241 27.9537 12.9494C25.5302 12.6032 23.667 10.5191 23.667 7.99988C23.667 7.48553 23.745 6.98819 23.89 6.51976C22.7494 5.56934 21.4352 4.8214 20.0027 4.33021C19.0915 5.54517 17.6386 6.33322 16.0003 6.33322C14.3621 6.33322 12.9091 5.54517 11.9979 4.33021C10.5654 4.8214 9.2513 5.56934 8.11068 6.51976Z"
            fill={color}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.333 16.0002C10.333 12.8705 12.8701 10.3335 15.9997 10.3335C19.1293 10.3335 21.6663 12.8705 21.6663 16.0002C21.6663 19.1298 19.1293 21.6668 15.9997 21.6668C12.8701 21.6668 10.333 19.1298 10.333 16.0002ZM15.9997 12.3335C13.9746 12.3335 12.333 13.9751 12.333 16.0002C12.333 18.0252 13.9746 19.6668 15.9997 19.6668C18.0247 19.6668 19.6663 18.0252 19.6663 16.0002C19.6663 13.9751 18.0247 12.3335 15.9997 12.3335Z"
            fill={color}
          />
        </svg>
      );
    case "information":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
          width={width}
          height={height}
          fill="#6fa3f1">
          <path d="M 25 2 C 12.309295 2 2 12.309295 2 25 C 2 37.690705 12.309295 48 25 48 C 37.690705 48 48 37.690705 48 25 C 48 12.309295 37.690705 2 25 2 z M 25 4 C 36.609824 4 46 13.390176 46 25 C 46 36.609824 36.609824 46 25 46 C 13.390176 46 4 36.609824 4 25 C 4 13.390176 13.390176 4 25 4 z M 25 11 A 3 3 0 0 0 22 14 A 3 3 0 0 0 25 17 A 3 3 0 0 0 28 14 A 3 3 0 0 0 25 11 z M 21 21 L 21 23 L 22 23 L 23 23 L 23 36 L 22 36 L 21 36 L 21 38 L 22 38 L 23 38 L 27 38 L 28 38 L 29 38 L 29 36 L 28 36 L 27 36 L 27 21 L 26 21 L 22 21 L 21 21 z" />
        </svg>
      );
    case "cancel-recurrence":
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 50 50"
          width="{width}"
          height="{height}"
          fill="#6fa3f1">
          <path d="M25 2C12.3 2 2 12.3 2 25s10.3 23 23 23 23-10.3 23-23S37.7 2 25 2zm0 2c11.6 0 21 9.4 21 21 0 4.2-1.3 8-3.5 11.1L13.9 7.5C17 5.3 20.8 4 25 4zm0 42c-11.6 0-21-9.4-21-21 0-4.2 1.3-8 3.5-11.1l28.6 28.6C33 44.7 29.2 46 25 46zM34 16h-5l2.5-2.5c-1.6-1.5-3.7-2.5-6-2.5-1.8 0-3.5.6-4.9 1.6l-2-2C20.5 8.6 22.7 8 25 8c3.3 0 6.3 1.3 8.5 3.5L34 10v6zm-18 18h5l-2.5 2.5c1.6 1.5 3.7 2.5 6 2.5 1.8 0 3.5-.6 4.9-1.6l2 2C29.5 41.4 27.3 42 25 42c-3.3 0-6.3-1.3-8.5-3.5L16 40v-6zM15 15l20 20-2 2-20-20 2-2z"/>
        </svg>
      );
    case "send-email":
      return (
        <svg
          width={width}
          height={height}
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <g transform="rotate(-30 12 12)">
            <path
              d="M2.01 21L23 12L2.01 3V10L17 12L2.01 14V21Z"
              fill={color}
            />
          </g>
        </svg>
      );
      
      default:
      return <svg />;
  }
}

export default Icons;
